import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ScrollArea from 'react-scrollbar';
import SVGInline from "react-svg-inline"
import { connect } from 'react-redux';

// components
import { About } from "../../Main/About";
import { Footer } from "../../Footer";
import { CounterVisits } from "../../Elements/Counters";


// actions
import { getDatatypes } from "../../../Actions/main";
import { getUserData } from "../../../Actions/users";

// utils

// svgs
import shineSVG from "../../inlineSVGs/shineSVG";
import tieMugicsBgSVG from "../../inlineSVGs/tieMugicsBgSVG";

// styles
import './Packages.css';
import { PackageOption } from "../../ScreenElements/PackageOption";
import { CollapsibleInfo } from "../../Elements/Collapsiblenfo";
import { isMobile } from "../../../utils";
import {ENROL_TYPE_FREE, ENROL_TYPE_HIGH, ENROL_TYPE_HUGE, ENROL_TYPE_MEDIUM} from "../../../Models/consts";

const US_STORY_TITLE = 'הויזין שלנו';
const US_STORY_TEXT = `
היי! אנחנו MUGICS

`

const US_STORY_TEXT_BOTTOM = `
פלטפורמה שמחברת בין קהל ומוזיקאים
ובין מוזיקאים לבין עצמם. 
`

const US_STORY_VISION_ONE = `
וזה הויז׳ן שלנו :
`
const US_STORY_VISION_ONE_BOTTOM = `
אחד, לקדם כמה שיותר הופעות אותנטיות אינטימיות ייחודיות ומרגשות ולדאוג שתהיה כמה שיותר מוזיקה חיה בעולם!
ושתיים, לדאוג שמוזיקאים יוכלו למצוא 
ולפרסם כל מה שהם צריכים לקריירה 
המוזיקלית שלהם: 
מורים, חדרי חזרות, אולפני הקלטות, מקומות להופיע, מנטורים, סדנאות, חברי להקה... 
ממש הכל!
`

const US_STORY_VISION_JOIN = `
הצטרפו למשפחת מיוזיקס
`

const US_STORY_VISION_JOIN_BOTTOM = `
וביחד נהפוך את החיים של מוזיקאים לקלים ונפיץ הרבה מוזיקה חיה ואהבה בעולם
`

class Packages extends Component {

    componentDidMount() {
        if (!this.props.datatypes) this.props.getDatatypes();
        if (!this.props.subscription || !this.props.subscription.enrolType) this.props.getUserData()

    }
    componentWillReceiveProps(nextProps) {
    }

    renderPackage(packageType, title, isPopular, packageClosed) {
        return (
            <PackageOption
                name={title}
                isPopular={isPopular}
                packageClosed={packageClosed}
                packageType={packageType}
            />
        )
    }

    renderStory(title, textTop, textBottom) {
        return (
            <div className="story-wrapper">
                {title ? <h3 className="story-title">{title}</h3> : null}
                <p className="story-text">{textTop}</p>
                <p className="story-text">{textBottom}</p>
            </div>
        )
    }

    renderQaBox(title, text, listKey) {
        return <CollapsibleInfo key={listKey} title={title} text={text} />
    }

    renderMobileTitle() {
        return (
            <div className="title-wrapper">
                <h1 className="title">בחר תוכנית וקחו את</h1>
                <h1 className="title">הקריירה המוזיקלית שלכם</h1>
                <h1 className="title">לשלב הבא</h1>
                <SVGInline style={{top: -21, right: 0}} width="25" className="us-star" svg={shineSVG()} component="i" />
                <SVGInline style={{bottom: -10, left: 55}} width="15" className="us-star" svg={shineSVG()} component="i" />
                <SVGInline style={{bottom: 3, left: 40}} width="18" className="us-star" svg={shineSVG()} component="i" />

            </div>
        )
    }

    renderWebTitle() {
        return (
            <div className="title-wrapper">
                <h1 className="title">בחר תוכנית וקחו את הקריירה</h1>
                <h1 className="title">המוזיקלית שלכם לשלב הבא</h1>
                <SVGInline style={{top: 50, right: -30}} width="15" className="us-star" svg={shineSVG()} component="i" />
                <SVGInline style={{top: 15, right: -50}} width="25" className="us-star" svg={shineSVG()} component="i" />
                <SVGInline style={{bottom: -20, left: -20}} width="18" className="us-star" svg={shineSVG()} component="i" />

            </div>
        )
    }

    render() {
        return (
            <div className="packages-container rtl">
                    <ScrollArea speed={0.8}
                                className={`area`}
                                horizontal={false}
                                contentClassName={'area-content'}
                    >
                        <div className="banner-wrapper">
                            {isMobile() ? this.renderMobileTitle() : this.renderWebTitle()}
                            <h2 className="subtitle">זה פשוט, אנחנו כאן כדי שאתם תתרכזו בלעשות מוזיקה</h2>
                            <h2 className="subtitle">ואנחנו נדאג לכל השאר</h2>

                            <CounterVisits count={2487} />

                        </div>

                        <div className="package-boxes-wrapper">

                            <div className={'packages-basic-wrapper'}>
                                <div className="package-basic-label">מוזיקאים להקות ועסקים קטנים</div>

                                {this.renderPackage(ENROL_TYPE_FREE, 'חינם')}
                                {this.renderPackage(ENROL_TYPE_MEDIUM, 'מוזיקאי')}
                                {this.renderPackage(ENROL_TYPE_HIGH, 'מוזיקאי פול טיים', true)}
                            </div>
                            <div className="packages-basic-wrapper">
                                <div className="separator-label">מקומות עם הופעות ועסקים</div>
                                {this.renderPackage(ENROL_TYPE_HUGE, 'חבילת ביזנס')}
                            </div>

                        </div>
                        <div className="us-wrapper">
                            <SVGInline style={{top: 240, right: 80}} width="15" className="us-star" svg={shineSVG()} component="i" />
                            <SVGInline style={{top: 260, left: 110}} width="18" className="us-star" svg={shineSVG()} component="i" />
                            <SVGInline style={{bottom: 77, left: 90}} width="25" className="us-star" svg={shineSVG()} component="i" />
                            <div className="icons-wrapper">
                                <SVGInline className="us-mugics-icon" svg={tieMugicsBgSVG} component="i"/>
                            </div>
                            {this.renderStory(US_STORY_TITLE, US_STORY_TEXT, US_STORY_TEXT_BOTTOM)}
                            {this.renderStory(null, US_STORY_VISION_ONE, US_STORY_VISION_ONE_BOTTOM)}
                            {this.renderStory(null, US_STORY_VISION_JOIN, US_STORY_VISION_JOIN_BOTTOM)}

                            <div className="story-separator"></div>
                            {/*<div className="us-img-wrapper">*/}
                            {/*    <img src={`${clientMedia()}/img/social/this-is-us.png`} alt="this-is-us"/>*/}
                            {/*</div>*/}
                        </div>
                        <div className="qa-wrapper">
                            <h2 className="qa-title">שאלות ותשובות</h2>
                            {qaArr.map((qa, index) => this.renderQaBox(qa.q, qa.a, index))}

                        </div>
                        <About isShowMobile isHideJoin isHideContact isNoText isNoTitle />
                        <Footer isShowFooter />
                    </ScrollArea>
            </div>
        )
    }
}
const mapStateToProps = state => ({
    datatypes: state.main.datatypes,
    subscription: state.users.subscription || {}
});

Packages.propTypes = {
    datatypes: PropTypes.object,
    subscription: PropTypes.object,
    getDatatypes: PropTypes.func,
    getUserData: PropTypes.func
};

export default connect(mapStateToProps, {
    getDatatypes,
    getUserData
})(Packages);

const qaArr = [
    {
        q: `ממש התחברתי לחזון שלכם איך מצטרפים?`,
        a: `MUGICS (מיוגי'קס) היא פלטפורמה שמחברת בין אוהבי הופעות אינטימיות לבין מוזיקאים שמופעים, וגם כדי לתת במה עסקית לכל נותני השירות בעולם המוזיקה, ככה שיהיה אפשר למצוא את כל מי ומה שקשור במוזיקה במקום אחד.  הדרך הכי טובה לעזור היא פשוט לפרסם את עצמכם בפלטפורמה ולעזור לנו להגדיל את הקהילה! וכן שיתופים של דף הפייסבוק שלנו. אנחנו מאמינים בגדילה אורגנית טבעית מפה לאוזן, שבנויה על אהבה למוזיקה`
    },
    {
        q: `איך MUGICS יכולה לעזור שיותר אנשים יבואו להופעה שלי?`,
        a: `לפני הכל MUGICS הוקמה כדי לדאוג שיהיו יותר הופעות אוטנטיות, וכיום MUGICS היא מרכז תוסס עם עשרות אלפי משתמשים שמחפשים הופעות חיות כל חודש. הקסם של MUGICS הוא בזה מאגר מחפשי ההופעות שלנו גדל כל הזמן, ושאנחנו יודעים להביא קהל ספציפי שמחפש הופעות אינטימיות ואוטנטיות.`
    },
    {
        q: `למה כדאי לפתוח דף עסק בMUGICS?`,
        a: `אלפי נותני שירות מעולם המוזיקה כבר בחרו להירשם ולקבל פניות מלקוחות שצריכים דווקא את השירות המוזיקלי שלהם, MUGICS היא כמו באזר למוזיקאים שאפשר למצוא בו הכל, וזה למה מי שנחשף לפלטפורמה חוזר אליה שוב ושוב.  אז מה אפשר למצוא ב MUGICS?! להקות לאירועים, מקומות להופיע בהם,  חדרי חזרות, אולפנים, מפיקים, מורים למוזיקה ועוד... הוויז'ן שלנו הוא שמוזיקאים יוכלו למצוא כל מה שהם צריכים לקרירה שלהם... ברגע!`
    },
    {
        q: `איך אני יודע איזה חבילה הכי מתאימה לי?`,
        a: `יש לנו כמה חבילות. כל החבילות בתשלום בפלטפורמת MUGICS מאפשרות העלאת מודעות Basic ללא הגבלה ככה שמוזיקאי או עסק יוכל לפרסם את כל מה שהם צריכים. ההבדל המרכזי בין החבילות הוא מספר החשיפות בפלטפורמה, ושמנוי יותר מתקדם מאפשר מודעות במיקום יותר גבוהה, מה שמביא בסופו של דבר יותר לקוחות לדף העסק ויותר אנשים להופעות.`
    },
    {
        q: `מה זה "מחבר הלהקות"?`,
        a: `מחבר הלהקות הוא כלי בMUGICS שמאפשר ללהקות להתגבש.  MUGICS היא פלטפורמה שנוצרה על ידי מוזיקאים למען מוזיקאים. בתור מוזיקאים אנחנו יודעים שלפעמים למצוא חבר ללהקה יכול לקחת זמן. בעזרת מחבר הלהקות של MUGICS אתם יכולים לפרסם את הלהקה שלכם ואיזה תפקיד חסר לה כרגע, או לחילופין להציע את עצמכם בתור מוזקאי שמחפש להצטרף ללהקה. באמצעות פילטור חכם אפשר לעשות בדיוק את החיבור בין "יוסי המתופף" שמחפש להקת פאנק לבין להקת "פאנקי פאנקי" שבדיוק כרגע צריכים מתופף... יוסי 😊`
    },
    {
        q: `האם הפרסום בפלטפורמה כרוך בתשלום?`,
        a: `כן ולא, אנחנו ב MUGICS נותנים לפרסם מודעת Basic אחת בחינם, מעבר לכך יש צורך להיות מנוי באחת החבילות שלנו. מעבר לזה שפרסום באמצעות מנוי מאפשר מודעות ללא הגבלה וחשיפה הרבה יותר רחבה לקהל גדול יותר. הוא גם מאפשר לנו להשקיע יותר משאבים בפלטפורמה שהמהות שלה היא לחבר בין אומנים וקהל, ולהפוך את החיים של מוזיקאים לכמה שיותר קלים פשוטים.`
    },
]



// WEBPACK FOOTER //
// ./src/Components/Modals/Packages/Packages.js